module.exports = "https://cdn.dove.it/_next/static/public/assets/building-sites/quintiliano5.6e6a881a774223bc3f79375eefe4aed9.jpg";